import React, { Fragment, useContext, useEffect, useState } from "react";
import localization from "../../../assets/localization/localization";
import Layout from "../../../components/sales/layout/layout";
import DivLayout from "../../../components/sales/divLayout/divLayout";
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import ModalPop from "components/sales/modal/modal";
import ConstantInput from "../../../components/sales/Input/constantInput/constantInput";
import TextAreaInput from "../../../components/sales/Input/textAreaInput/textAreaInput";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { Button } from "react-bootstrap";
import {toast} from "react-toastify";
import moment from "moment/moment";
import { ReInvoicingMapping, ReconResponse } from "components/UI";
import {
    REGENERATION_INVOICE_USE_CASE_ID,
    getPiTiErrorsByUseCase,
} from "../../UserConfig/UserRequest/userRequestPiTiValidation";

const UserRequestView = ({
                             userRequestById,
                             requestByIdDetails = [],
                             match,
                             documentUploadUrlPublic,
                             documentUrlDataPublic,
                             history,
                             approvedResponse=[],
                             approval,
                             backToModificationRequest,
                             modificationRequest=[],
                             backToModificationResponse,
                             modificationResponse=[]
                         }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState();
    const [isModal, setIsModal] = useState(false);
    const [remark, setRemark] = useState("");
    const [tiNo, setTiNo] = useState("");
    const [piNo, setPiNo] = useState("");
    const [count, setCount] = useState(0);
    const [userId, setUserId] = useState(0)
    const [openModalForModification, setOpenModalForModification] = useState(false)
    const [openModalForModificationResponse, setOpenModalForModificationResponse] = useState(false)
    const [documents, setDocuments] = useState([]);
    const [modalTitle, setModalTitle] = useState("Rejection");
    const [roleId, setRoleId] = useState('');

    const FINANCE_APPROVED_STATUS = "Finance Approved";

    const isRegenerationInvoice =
        parseInt(requestByIdDetails?.use_case_id, 10) === REGENERATION_INVOICE_USE_CASE_ID;

    const piTiErrors = getPiTiErrorsByUseCase(
        requestByIdDetails?.use_case_id,
        piNo,
        tiNo,
        {
            piTiEitherSingleRequired: localization.piTiEitherSingleRequired,
            piTiSingleOnly: localization.piTiSingleOnly,
        }
    );

    useEffect(() => {
        (async () => {
            let userDetails = JSON.parse(localStorage.getItem("loginDetails"));
            setUserId(userDetails?.id)
            setRoleId(localStorage.getItem("fusion-role"))
            setIsLoading(true);
            await userRequestById(match?.params?.id);
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        setTiNo(requestByIdDetails?.TI_no ?? "");
        setPiNo(requestByIdDetails?.PI_no ?? "");
    }, [requestByIdDetails?.TI_no, requestByIdDetails?.PI_no]);

    const handleModalHide = () => {
        setIsModal(false);
        setOpenModalForModificationResponse(false)
        setOpenModalForModification(false)
    };

    const handleContinue = () => {
        (async () => {
            setIsModal(false);
            const list = {};
            list["remarks"] = remark;
            list["attachment"] = documents;
            list["status"] = status;
            list["request_id"] = requestByIdDetails?.request_id;
            setIsLoading(true);
            await approval(list);
            setIsLoading(false);
            setCount(count + 1);
            setStatus(1);
        })();
    };

    const handleApproval = (e, status, isReject = false) => {
        e.preventDefault()
        setStatus(status)
        setIsModal(true)
        if(!isReject){
            setModalTitle("Approval");
        }
    }

    const handleBackToModificationRequest = async () => {
        let list = {
            request_id:requestByIdDetails?.id,
            remark:remark,
            finance_attachment:documents
        }

        setIsLoading(true)
        await backToModificationRequest(list)
        setIsLoading(false)
    }

    const handleBackToModificationResponse = async (id) => {
        if(!remark || !remark.trim()){
            toast.warning("Reason is required")
            return
        }

        if(isRegenerationInvoice && (!tiNo || !tiNo.trim() || !piNo || !piNo.trim())){
            toast.warning("TI No and PI No are required")
            return
        }

        if(piTiErrors.tiError || piTiErrors.piError){
            toast.warning(piTiErrors.tiError || piTiErrors.piError)
            return
        }

        let list = {
            request_id:requestByIdDetails?.id,
            remark:remark,
            attachment:documents,
            modification_id:requestByIdDetails?.modification_id,
            TI_no:tiNo,
            PI_no:piNo
        }

        setIsLoading(true)
        await backToModificationResponse(list)
        setIsLoading(false)
    }

    const headerBtns = () => {
        return (
            <Fragment>
                {/* will open for user to make finance response of modification */}
                {parseInt(requestByIdDetails?.current_status) === 10 && parseInt(requestByIdDetails?.user_id) === parseInt(userId) &&
                    <Button type="button" className="filter-hamburger btn btn-transparent" onClick={() => setOpenModalForModificationResponse(true)}>Response Against Modification Request</Button>
                }

                {/* will open for finance head to send for modification */}
                {parseInt(requestByIdDetails?.current_status) === 7 && parseInt(roleId) === 13 &&
                    <Button type="button" className="filter-hamburger btn btn-transparent btn-warning" onClick={() => setOpenModalForModification(true)}>Send To Modification</Button>
                }

                {/* this must be work if we already know who is approval person */}
                {requestByIdDetails?.approved_status !== undefined && requestByIdDetails?.approval_person !== undefined && parseInt(requestByIdDetails?.approval_person) === parseInt(userId) &&
                    <Fragment>
                        <Button type="button" className="filter-hamburger btn btn-transparent btn-danger" onClick={(e) => handleApproval(e, requestByIdDetails?.rejected_status, true)}>Reject</Button>
                        <Button type="button" className="filter-hamburger btn btn-transparent btn-success" onClick={(e) => handleApproval(e, requestByIdDetails?.approved_status)}>Approve</Button>
                    </Fragment>
                }

                {/* this must be work approval is pending from finance */}
                {requestByIdDetails?.approved_status !== undefined && (requestByIdDetails?.approval_person === undefined || requestByIdDetails?.approval_person === null) && parseInt(roleId) === 13 &&
                    <Fragment>
                        <Button type="button" className="filter-hamburger btn btn-transparent btn-danger" onClick={(e) => handleApproval(e, requestByIdDetails?.rejected_status, true)}>Reject</Button>
                        <Button type="button" className="filter-hamburger btn btn-transparent btn-success" onClick={(e) => handleApproval(e, requestByIdDetails?.approved_status)}>Approve</Button>
                    </Fragment>
                }
            </Fragment>
        );
    };

    useEffect(() => {
        if(modificationRequest?.status !== undefined){
            if(parseInt(modificationRequest?.status) === 200){
                setOpenModalForModification(false)
                toast.success(modificationRequest?.message)
                setTimeout(() => {
                    window.location.reload()
                }, 1000)

            }else if(parseInt(modificationRequest?.status) === 400){
                toast.warning(modificationRequest?.message)
            }
        }
    }, [modificationRequest])

    useEffect(() => {
        if(modificationResponse?.status !== undefined){
            if(parseInt(modificationResponse?.status) === 200){
                setOpenModalForModificationResponse(false)
                toast.success(modificationResponse?.message)
                setTimeout(() => {
                    window.location.reload()
                }, 1000)
            }else if(parseInt(modificationResponse?.status) === 400){
                toast.warning(modificationResponse?.message)
            }
        }
    }, [modificationResponse])

    useEffect(() => {
        if(approvedResponse?.status !== undefined){
            if(parseInt(approvedResponse?.status) === 200){
                setIsModal(false)
                toast.success(modificationRequest?.message)
                setTimeout(() => {
                    window.location.reload()
                }, 1000)
            }else if(parseInt(approvedResponse?.status) === 400){
                toast.warning(approvedResponse?.message)
            }
        }
    }, [approvedResponse])


    return (
        <>
            <Layout title={localization.transactionRequestView} isLoading={isLoading} isGoback={true} Buttons={headerBtns}>
                <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">{localization.RequestDetails}</div>
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                            <DivLayout heading={"Requested Id"} data={requestByIdDetails?.request_id} />

                            <DivLayout heading={"Requested By"} data={requestByIdDetails?.request_name} />

                            <DivLayout heading={"Requested Date"} data={requestByIdDetails?.requested_date} />

                            <DivLayout
                                heading={"Use Case"}
                                data={requestByIdDetails?.use_case_name}
                            />

                            <DivLayout
                                heading={"Status"}
                                data={requestByIdDetails?.status}
                            />

                            {requestByIdDetails?.TI_no !== null && (
                                <DivLayout
                                    heading={"TI No"}
                                    data={requestByIdDetails?.TI_no}
                                />
                            )}

                            {requestByIdDetails?.PI_no !== null && (
                                <DivLayout
                                    heading={"PI No"}
                                    data={requestByIdDetails?.PI_no}
                                />
                            )}
                            <DivLayout heading={"User Remark"} data={requestByIdDetails?.user_remark} />
                        </div>

                        {parseInt(requestByIdDetails?.use_case_id, 10) === REGENERATION_INVOICE_USE_CASE_ID &&
                            requestByIdDetails?.PI_no && requestByIdDetails?.TI_no && (
                                <div className="reinvoicing-mapping-block">
                                    <div className="reinvoicing-mapping-block__title">
                                        {"Re-Invoicing Mapping"}
                                    </div>
                                    <ReInvoicingMapping
                                        piNo={requestByIdDetails?.PI_no}
                                        tiNo={requestByIdDetails?.TI_no}
                                    />
                                </div>
                            )}
                    </div>
                </div>

                {requestByIdDetails && requestByIdDetails?.status && requestByIdDetails?.use_case_id === REGENERATION_INVOICE_USE_CASE_ID && (requestByIdDetails?.status === FINANCE_APPROVED_STATUS) && (
                    <div className="panel-card card-details" width="100%">
                        <div className="panel-heading">{"Recon Response"}</div>
                        <div className="panel-body">
                            <ReconResponse
                                reconStatus={requestByIdDetails?.recon_status}
                                reconResponse={requestByIdDetails?.recon_response}
                            />
                        </div>
                    </div>
                )}

                <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">
                        {'User Details(Darwinbox)'}
                    </div>
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                            <div className="row">
                                {requestByIdDetails?.designation_name !== null && (
                                    <DivLayout
                                        heading={"Designation Name"}
                                        data={requestByIdDetails?.designation_name}
                                    />
                                )}

                                {requestByIdDetails?.department_name !== null && (
                                    <DivLayout
                                        heading={"Department Name"}
                                        data={requestByIdDetails?.department_name}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {requestByIdDetails?.user_attachment !== undefined && requestByIdDetails?.user_attachment !== null &&
                    requestByIdDetails?.user_attachment[0] !== undefined &&
                    requestByIdDetails?.user_attachment[0] !== null && (
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">
                                {localization.userUploadedDocument}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="row">
                                        {requestByIdDetails?.user_attachment.map((val) => {
                                            return (
                                                <>
                                                    {val!== "" && val !== null && (
                                                        <div className="col-md-4">
                                                            <DocumentView
                                                                title={localization.attachment}
                                                                attachment={val}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                {requestByIdDetails?.a1_by !== '' && requestByIdDetails?.a1_by !== null &&
                    <>
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">
                                {'Manager Approval(L1) Details'}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="row">
                                        {requestByIdDetails?.a1_approval_name !== null && (
                                            <DivLayout
                                                heading={"Approved Name"}
                                                data={requestByIdDetails?.a1_approval_name}
                                            />
                                        )}

                                        {requestByIdDetails?.a1_approval_status !== null && (
                                            <DivLayout
                                                heading={"Status"}
                                                data={requestByIdDetails?.a1_approval_status}
                                            />
                                        )}
                                        {requestByIdDetails?.a1_action_date !== null && (
                                            <DivLayout
                                                heading={"Approved Date"}
                                                data={requestByIdDetails?.a1_action_date}
                                            />
                                        )}

                                        {requestByIdDetails?.a1_remark !== null && (
                                            <DivLayout
                                                heading={"Remark"}
                                                data={requestByIdDetails?.a1_remark}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {requestByIdDetails?.a1_attachment !== undefined && requestByIdDetails?.a1_attachment !== null &&
                    requestByIdDetails?.a1_attachment[0] !== undefined &&
                    requestByIdDetails?.a1_attachment[0] !== null && (
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">
                                {"Approval(L1) Attachment"}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="row">
                                        {requestByIdDetails?.a1_attachment.map((val) => {
                                            return (
                                                <>
                                                    {val!== "" && val !== null && (
                                                        <div className="col-md-4">
                                                            <DocumentView
                                                                title={localization.attachment}
                                                                attachment={val}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                {requestByIdDetails?.a2_by !== '' && requestByIdDetails?.a2_by !== null &&
                    <>
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">
                                {'Manager Approval(L2) Details'}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="row">
                                        {requestByIdDetails?.a2_approval_name !== null && (
                                            <DivLayout
                                                heading={"Approved Name"}
                                                data={requestByIdDetails?.a2_approval_name}
                                            />
                                        )}

                                        {requestByIdDetails?.a2_approval_status !== null && (
                                            <DivLayout
                                                heading={"Status"}
                                                data={requestByIdDetails?.a1_approval_status}
                                            />
                                        )}

                                        {requestByIdDetails?.a2_action_date !== null && (
                                            <DivLayout
                                                heading={"Approved Date"}
                                                data={requestByIdDetails?.a2_action_date}
                                            />
                                        )}

                                        {requestByIdDetails?.a2_remark !== null && (
                                            <DivLayout
                                                heading={"Remark"}
                                                data={requestByIdDetails?.a2_remark}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {requestByIdDetails?.a2_attachment !== undefined && requestByIdDetails?.a2_attachment !== null &&
                    requestByIdDetails?.a2_attachment[0] !== undefined &&
                    requestByIdDetails?.a2_attachment[0] !== null && (
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">
                                {"Approval(L2) Attachment"}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="row">
                                        {requestByIdDetails?.a2_attachment.map((val) => {
                                            return (
                                                <>
                                                    {val!== "" && val !== null && (
                                                        <div className="col-md-4">
                                                            <DocumentView
                                                                title={localization.attachment}
                                                                attachment={val}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                {requestByIdDetails?.finance_action_by !== '' && requestByIdDetails?.finance_action_by !== null &&
                    <>
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">
                                {'Finance Approval Details'}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="row">
                                        {requestByIdDetails?.finance_approval_name !== null && (
                                            <DivLayout
                                                heading={"Approved Name"}
                                                data={requestByIdDetails?.finance_approval_name}
                                            />
                                        )}

                                        {requestByIdDetails?.finance_status !== null && (
                                            <DivLayout
                                                heading={"Status"}
                                                data={requestByIdDetails?.finance_status}
                                            />
                                        )}

                                        {requestByIdDetails?.finance_action_date !== null && (
                                            <DivLayout
                                                heading={"Approved Date"}
                                                data={requestByIdDetails?.finance_action_date}
                                            />
                                        )}

                                        {requestByIdDetails?.finance_remark !== null && (
                                            <DivLayout
                                                heading={"Remark"}
                                                data={requestByIdDetails?.finance_remark}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {requestByIdDetails?.finance_attachment !== undefined && requestByIdDetails?.finance_attachment !== null &&
                    requestByIdDetails?.finance_attachment[0] !== undefined &&
                    requestByIdDetails?.finance_attachment[0] !== null && (
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">
                                {"Finance Attachment"}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="row">
                                        {requestByIdDetails?.finance_attachment.map((val) => {
                                            return (
                                                <>
                                                    {val!== "" && val !== null && (
                                                        <div className="col-md-4">
                                                            <DocumentView
                                                                title={localization.attachment}
                                                                attachment={val}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                {requestByIdDetails?.send_back_to_modification !== undefined && requestByIdDetails?.send_back_to_modification !== [] && requestByIdDetails?.send_back_to_modification.length > 0 &&
                    <>
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">
                                {"Back To Modification"}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <div className="">
                                        {requestByIdDetails?.send_back_to_modification.map((val, i) => {
                                            return (
                                                <>
                                                    <div className="panel-card card-details" width="100%">
                                                        <div className="panel-heading">
                                                            {"Request "+(i+1)}
                                                        </div>
                                                        <div className="panel-body">
                                                            <div className="details-listing detail_alignment">
                                                                <div className="row">
                                                                    {val?.finance_remark !== null && (
                                                                        <DivLayout
                                                                            heading={"Finance Remark"}
                                                                            data={val?.finance_remark}
                                                                        />
                                                                    )}
                                                                    <DivLayout
                                                                        heading={"Requested Date"}
                                                                        data={moment(val?.created_at).format('DD-MMMM-YYYY H:mm:ss')}
                                                                    />
                                                                    {val?.finance_attachment !== null && val?.finance_attachment.map((value) => {
                                                                        return (
                                                                            <>
                                                                                {value!== "" && value !== null && (
                                                                                    <div className="col-md-4">
                                                                                        <DocumentView
                                                                                            title={localization.attachment}
                                                                                            attachment={value}
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        );
                                                                    })}
                                                                </div>
                                                                <div style={{color:"#6c7ae0", marginLeft:"-12px"}}>
                                                                    {"User Response"}
                                                                </div>
                                                                <hr/>
                                                                {val?.user_remark !=='' && val?.user_remark !== null &&
                                                                    <>
                                                                        <div className="row">
                                                                            <DivLayout
                                                                                heading={"User Remark"}
                                                                                data={val?.user_remark}
                                                                            />
                                                                            <DivLayout
                                                                                heading={"Response Date"}
                                                                                data={moment(val?.updated_at).format('DD-MMMM-YYYY H:mm:ss')}
                                                                            />
                                                                            {val?.user_attachment !== null && val?.user_attachment.map((value) => {
                                                                                return (
                                                                                    <>
                                                                                        {value!== "" && value !== null && (
                                                                                            <div className="col-md-4">
                                                                                                <DocumentView
                                                                                                    title={localization.attachment}
                                                                                                    attachment={value}
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </>
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

                <ModalPop
                    title={
                        'Response Against Modification Request'
                    }
                    show={openModalForModificationResponse}
                    handleModalHide={handleModalHide}
                >
                    <>
                        <div className="modal-body">
                                <div className="form-group row">
                                    {requestByIdDetails?.TI_no !== null && requestByIdDetails?.TI_no !== undefined && (
                                        <div className="col-sm-12">
                                            <ConstantInput
                                                label={isRegenerationInvoice ? localization.tiNoCommaSeparated : localization.tiNo}
                                                fullWidth
                                                type="text"
                                                value={tiNo}
                                                required={isRegenerationInvoice}
                                                isStarRequired={isRegenerationInvoice}
                                                blockError={!!piTiErrors.tiError}
                                                errorMsg={piTiErrors.tiError}
                                                handleChange={(val) => {
                                                    setTiNo(val);
                                                }}
                                            />
                                        </div>
                                    )}
                                    {requestByIdDetails?.PI_no !== null && requestByIdDetails?.PI_no !== undefined && (
                                        <div className="col-sm-12">
                                            <ConstantInput
                                                label={isRegenerationInvoice ? localization.piNoCommaSeparated : localization.piNo}
                                                fullWidth
                                                type="text"
                                                value={piNo}
                                                required={isRegenerationInvoice}
                                                isStarRequired={isRegenerationInvoice}
                                                blockError={!!piTiErrors.piError}
                                                errorMsg={piTiErrors.piError}
                                                handleChange={(val) => {
                                                    setPiNo(val);
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className="col-sm-12">
                                        <TextAreaInput
                                            label={localization.addRemark}
                                            type="text"
                                            rows={4}
                                            required
                                            isStarRequired={true}
                                            value={remark}
                                            inputValue={remark}
                                            errorMsg={localization.isRequired}
                                            handleChange={(e) => {
                                                setRemark(e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <FileUpload
                                            id="agreementContractUpload"
                                            accept=".pdf,.png,.jpg,.jpeg,.doc, .xlsx,.csv,.doc,.pdf"
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            onChange={(val) => setDocuments(val)}
                                            multiple={true}
                                        >
                                    <span className="btn btn-transparent">
                                        {localization.uploadDocs}
                                        {/* <span style={{color:'red'}}>*</span> */}
                                    </span>
                                        </FileUpload>
                                    </div>
                                </div>
                                <Button
                                    className="btn btn-primary"
                                    onClick={() => handleBackToModificationResponse()}
                                >
                                    {localization.continue}{" "}
                                    <img src="../images/arrow-right.png" alt="" />
                                </Button>
                        </div>
                    </>
                </ModalPop>

                <ModalPop
                    title={
                        localization.backToModification
                    }
                    show={openModalForModification}
                    handleModalHide={handleModalHide}
                >
                    <>
                        <div className="modal-body">
                            <div className="text-center">
                                <div className="form-group">
                                    <div className="col-sm-8">
                                        <ConstantInput
                                            label={localization.addRemark}
                                            required
                                            isStarRequired={true}
                                            type="text"
                                            handleChange={(val) => {
                                                setRemark(val);
                                            }}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <FileUpload
                                            id="agreementContractUpload"
                                            accept=".pdf,.png,.jpg,.jpeg,.doc, .xlsx,.csv,.doc,.pdf"
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            onChange={(val) => setDocuments(val)}
                                            multiple={true}
                                        >
                      <span className="btn btn-transparent">
                        {localization.uploadDocs}
                          {/* <span style={{color:'red'}}>*</span> */}
                      </span>
                                        </FileUpload>
                                    </div>
                                </div>
                                <Button
                                    className="btn btn-primary"
                                    onClick={() => handleBackToModificationRequest()}
                                >
                                    {localization.continue}{" "}
                                    <img src="../images/arrow-right.png" alt="" />
                                </Button>
                            </div>
                        </div>
                    </>
                </ModalPop>

                <ModalPop
                    title={
                        modalTitle
                    }
                    show={isModal}
                    handleModalHide={handleModalHide}
                >
                    <>
                        <div className="modal-body">
                            <div className="text-center">
                                <div className="form-group">
                                    <div className="col-sm-8">
                                        <ConstantInput
                                            label={localization.addRemark}
                                            required
                                            isStarRequired={true}
                                            type="text"
                                            handleChange={(val) => {
                                                setRemark(val);
                                            }}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <FileUpload
                                            id="agreementContractUpload"
                                            accept=".pdf,.png,.jpg,.jpeg,.doc, .xlsx,.csv,.doc,.pdf"
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            onChange={(val) => setDocuments(val)}
                                            multiple={true}
                                        >
                      <span className="btn btn-transparent">
                        {localization.uploadDocs}
                          {/* <span style={{color:'red'}}>*</span> */}
                      </span>
                                        </FileUpload>
                                    </div>
                                </div>
                                <Button
                                    className="btn btn-primary"
                                    onClick={() => handleContinue()}
                                >
                                    {localization.continue}{" "}
                                    <img src="../images/arrow-right.png" alt="" />
                                </Button>
                            </div>
                        </div>
                    </>
                </ModalPop>

            </Layout>
        </>
    );
};

export default UserRequestView;
